import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: 1, // Decimal
    A_PayMode: "CREDIT",
    A_Type: "",
    A_Br: "", //LocationBrCode
    A_BrName: "", //location branchName
    A_Loc: "",
    A_LocName: "",
    A_Buyer: "",
    A_Buyername: "",
    A_Narr: "",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    A_GrossAmt: 0, //decimal
    A_DiscPerc: 0, //decimal
    A_DiscAmt: 0, //decimal
    A_Rounding: 0, //decimal
    A_TaxAmt: 0, //decimal
    A_NetAmt: 0, //decimal
    A_DocStat: "ENTER",
    TaxType: "INTRN001", //tax  ->      // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
    TaxTypeName: "",
    UnloadingBay: "", // Unloading Bin ID
    UnloadingBayName: "", // Unloading Bin Name

    A_ExciseTaxNetAmt: 0, //Decimal
    A_TaxGross: "N",
    A_Taxable: "Y",
    Source: "",
    A_RefDocTyp: "",
    A_RefDocTypName: "",
    A_RefDocNo: "",
    A_RefDocVer: 0, //Int
    offer: "N", // Offer Y/N
  },
  // BufferObject: {
  //   B_VocTyp: "",
  //   B_VocNo: "",
  //   B_Srno: 0,
  //   B_Itmcd: "",
  //   B_ItmName: "",
  //   B_Qty: 0,
  //   B_Unit: "",
  //   B_UnitName: "",
  //   B_BaseQty: 0,
  //   B_URateFc: 0,
  //   B_URateLc: 0,
  //   B_GrossAmt: 0,
  //   B_LDiscPerc: 0,
  //   B_LDiscAmt: 0,
  //   B_TDiscPerc: 0.00,
  //   B_TDiscAmt: 0,
  //   B_FocFlag: "N",
  //   B_AprmtFlag: "",
  //   B_FocAmt: 0,
  //   B_NetAmt: 0,
  //   B_TaxDept: "",
  //   B_TaxPerc: 0,
  //   B_TaxAmt: 0,
  //   B_TaxDept2: "",
  //   B_TaxPerc2: 0,
  //   B_TaxAmt2: 0,
  //   B_LC: 0,
  //   B_Charges1: 0,
  //   B_Charges2: 0,
  //   B_Rounding: 0,
  //   B_LandVal: 0,
  //   B_RSP: 0,
  //   B_RefDocTyp: "",
  //   B_RefDocNo: "",
  //   B_RefNo1: "",
  //   B_RefNo2: "",
  //   B_RefNo3: "",
  //   B_RefNo4: 0,
  //   B_RefNo5: 0,
  //   B_RefNo6: 0,
  //   B_URate_Fixed: 0,
  //   B_CostPr: 0,
  //   B_ExciseTaxPerc: 0,
  //   B_ExciseTaxAmt: 0,
  //   B_ExciseTaxNetAmt: 0,
  //   B_IncGroup: "",
  //   B_SuprvPerc: 0,
  //   B_OthersPerc: 0,
  //   B_SLANSuprv: "",
  //   B_SlabAmtSuprv: 0,
  //   B_SLANOther: "",
  //   B_SlabAmtOther: 0
  // },

  WmsOutboundGRVCheckbox: {
    SplDisc: false,
    TDiscPercent: false,
    TDiscAmt: false,
    LDiscPercent: true,
    LDiscAmt: true,
    // FOC: false,
    Excise: false,
    // BaseRate: false,
    Tax: true,
    // Rebate: false,
    // Narration: false,
    Cess: false,
    AddCess: false,
  },
};

const SliceWmsOutboundGRV = createSlice({
  name: "SliceWmsOutboundGRV",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WmsOutboundGRV_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_WmsOutboundGRV_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    //RESET CHECKBOX
    Set_WmsInnModelCheckbox_Init: (state) => {
      state.value.WmsOutboundGRVCheckbox = {
        SplDisc: false,
        TDiscPercent: false,
        TDiscAmt: false,
        LDiscPercent: true,
        LDiscAmt: true,
        FOC: false,
        Excise: false,
        // BaseRate: false,
        Tax: true,
        Rebate: false,
        Narration: false,
        Cess: false,
        AddCess: false,
      };
    },

    Set_OutboundGRV_HeadObject_DrCrAccount: (state, action) => {
      state.value.HeadObject.A_CrAc = action.payload.A_CrAc;
      state.value.HeadObject.A_CrAcName = action.payload.A_CrAcName;
      state.value.HeadObject.A_DrAc = action.payload.A_DrAc;
      state.value.HeadObject.A_DrAcName = action.payload.A_DrAcName;
    },

    Set_WmsOutboundGRV_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_WmsInnModelCheckbox: (state, action) => {
      state.value.WmsOutboundGRVCheckbox = action.payload;
    },

    Wms_OutboundGRV_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.TaxType = action.payload.TaxType;
      state.value.HeadObject.UnloadingBay = action.payload.UnloadingBay;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.offer = action.payload.offer;
    },

    Set_OutboundGRV_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Wms_HeadObject_Buyer_Set: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
    },
    Set_OutboundGRV_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_OutboundGRV_HeadObject_A_Buyer: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
    },

    Set_OutboundGRV_HeadObject_A_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
    Set_OutboundGRV_HeadObject_TaxType: (state, action) => {
      state.value.HeadObject.TaxType = action.payload.TaxType;
    },
  },
});

export const {
  Set_WmsOutboundGRV_Init,
  Set_WmsOutboundGRV_HeadObject_Set,
  Set_WmsInnModelCheckbox,
  Set_WmsInnModelCheckbox_Init,
  Wms_OutboundGRV_HeadObject_New_Set,
  Set_WmsOutboundGRV_HeadObject_Init,
  Set_OutboundGRV_HeadObject_DrCrAccount,
  Set_OutboundGRV_HeadObject_A_VocNo,
  Set_OutboundGRV_HeadObject_A_DocStat,
  Set_OutboundGRV_HeadObject_A_PayMode,
  Set_OutboundGRV_HeadObject_A_Buyer,
  Set_OutboundGRV_HeadObject_TaxType,
  Wms_HeadObject_Buyer_Set,
} = SliceWmsOutboundGRV.actions;
export default SliceWmsOutboundGRV.reducer;
